module.exports = __webpack_public_path__ + "static/img/bg6.a58a5ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bg6.png
// module id = 3bBE
// module chunks = 1